import {
  avatar_colorFallback01,
  avatar_colorFallback02,
  avatar_colorFallback03,
  avatar_colorFallback04,
  avatar_colorFallback05,
  avatar_colorFallback06,
  avatar_colorFallback07,
  avatar_colorFallback08,
  avatar_colorFallback09,
  avatar_colorFallback10,
  avatar_colorFallback11,
  avatar_colorFallback12,
} from 'ext-ui/style/colors'
import { UserAvatarColor } from 'src/models/user.models'

const avatarFallbackColors: Record<UserAvatarColor, string> = {
  [UserAvatarColor.AvatarColor01]: avatar_colorFallback01,
  [UserAvatarColor.AvatarColor02]: avatar_colorFallback02,
  [UserAvatarColor.AvatarColor03]: avatar_colorFallback03,
  [UserAvatarColor.AvatarColor04]: avatar_colorFallback04,
  [UserAvatarColor.AvatarColor05]: avatar_colorFallback05,
  [UserAvatarColor.AvatarColor06]: avatar_colorFallback06,
  [UserAvatarColor.AvatarColor07]: avatar_colorFallback07,
  [UserAvatarColor.AvatarColor08]: avatar_colorFallback08,
  [UserAvatarColor.AvatarColor09]: avatar_colorFallback09,
  [UserAvatarColor.AvatarColor10]: avatar_colorFallback10,
  [UserAvatarColor.AvatarColor11]: avatar_colorFallback11,
  [UserAvatarColor.AvatarColor12]: avatar_colorFallback12,
}

export const getAvatarFallbackColor = (
  avatarColor?: UserAvatarColor | null,
): string | undefined =>
  avatarColor === undefined || avatarColor === null
    ? undefined
    : avatarFallbackColors[avatarColor]
